// import React from "react";
// import { Link } from "react-router-dom";
// import { motion, useReducedMotion } from "framer-motion";
// import {
//   Shield,
//   ChartColumn,
//   Zap,
//   GitMerge,
//   CheckCircle2,
//   Smartphone,
//   Rocket,
//   Cpu,
//   Cloud,
//   Database,
//   Code,
//   Globe,
//   Lock,
//   Layers,
//   Brain,
//   Gauge,
//   Binary,
//   GitBranch,
//   Workflow,
//   Settings,
//   TrendingUp,
//   ArrowRight,
//   ChevronDown,
//   RefreshCw,
//   Users,
// } from "lucide-react";
// import TechnologyImage from "../../assets/Technology.jpeg";
// // NOTE: adjust this path to wherever Seo.js lives in your project
// import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";

// const PATH = "/technology";
// const TITLE = "Technology | AI-Powered Lead Management Platform | LMSBOTS";
// const DESCRIPTION =
//   "Explore LMSBOTS enterprise-grade AI-powered lead management technology: intelligent lead scoring, omnichannel capture, workflow automation, real-time analytics, and scalable cloud infrastructure.";

// // ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
// const HERO_POINTS = ["AI lead scoring", "Workflow automation", "Real-time analytics"];

// const FEATURES = [
//   {
//     icon: Brain,
//     title: "AI-Powered Lead Scoring & Predictive Analytics",
//     desc: "Machine learning analyzes prospect behavior, engagement, and demographics, then scores leads by conversion probability so your team works high-value opportunities first.",
//   },
//   {
//     icon: Globe,
//     title: "Omnichannel Lead Capture & Integration",
//     desc: "Capture leads from websites, mobile apps, social platforms, chatbots, and third-party CRMs. Unified APIs keep every channel in real-time sync with a single source of truth.",
//   },
//   {
//     icon: Workflow,
//     title: "Intelligent Workflow Automation Engine",
//     desc: "Design nurturing workflows with a drag-and-drop builder. Trigger personalized emails, SMS campaigns, task assignments, and reminders based on behavior or custom conditions.",
//   },
//   {
//     icon: Gauge,
//     title: "Real-Time Analytics & Custom Dashboards",
//     desc: "Customizable dashboards surface conversion funnels, cohort analysis, and ROI tracking in real time, with API export for custom reporting.",
//   },
//   {
//     icon: Lock,
//     title: "Enterprise-Grade Security & Compliance",
//     desc: "End-to-end encryption, SOC 2 Type II compliance, GDPR readiness, and role-based access control keep sensitive lead data protected at all times.",
//   },
//   {
//     icon: Cloud,
//     title: "Scalable Cloud Infrastructure",
//     desc: "Auto-scaling cloud architecture handles millions of leads with a 99.99% uptime SLA, global CDN delivery, and cost-efficient serverless scaling.",
//   },
// ];

// const TECH_STACK = [
//   {
//     icon: Brain,
//     title: "AI & Machine Learning",
//     desc: "Neural networks for lead scoring and prediction",
//     tech: "TensorFlow, PyTorch, scikit-learn",
//   },
//   {
//     icon: Cloud,
//     title: "Cloud Infrastructure",
//     desc: "Multi-cloud deployment with auto-scaling",
//     tech: "AWS, Azure, Kubernetes, Docker",
//   },
//   {
//     icon: Database,
//     title: "Data Processing",
//     desc: "Real-time stream processing at scale",
//     tech: "Apache Kafka, Redis, PostgreSQL",
//   },
//   {
//     icon: Lock,
//     title: "Security Framework",
//     desc: "Zero-trust architecture with encryption",
//     tech: "AES-256, SSL/TLS, OAuth 2.0",
//   },
//   {
//     icon: Code,
//     title: "API & Integration",
//     desc: "RESTful APIs with comprehensive documentation",
//     tech: "GraphQL, Webhooks, OpenAPI",
//   },
//   {
//     icon: Smartphone,
//     title: "Omnichannel Delivery",
//     desc: "Multi-channel communication engine",
//     tech: "Twilio, SendGrid, WhatsApp API",
//   },
// ];

// const WORKFLOW = [
//   {
//     icon: Binary,
//     title: "Data Ingestion",
//     steps: ["Multi-source capture", "Data enrichment", "Deduplication", "Validation layer"],
//   },
//   {
//     icon: Brain,
//     title: "Intelligent Processing",
//     steps: ["AI scoring", "Behavior analysis", "Segmentation", "Priority routing"],
//   },
//   {
//     icon: GitBranch,
//     title: "Workflow Execution",
//     steps: ["Automated sequences", "Multi-channel delivery", "A/B testing", "Performance tracking"],
//   },
//   {
//     icon: ChartColumn,
//     title: "Analytics & Optimization",
//     steps: ["Real-time dashboards", "Conversion analysis", "ROI reporting", "Continuous improvement"],
//   },
// ];

// const BENEFITS = [
//   {
//     icon: Zap,
//     title: "Real-time processing",
//     desc: "Sub-second lead capture and distribution across every channel.",
//   },
//   {
//     icon: Brain,
//     title: "Predictive lead scoring",
//     desc: "Analytics that forecast deal closure with 94% accuracy.",
//   },
//   {
//     icon: GitMerge,
//     title: "Smart routing",
//     desc: "Intelligent lead assignment based on multiple criteria.",
//   },
//   {
//     icon: TrendingUp,
//     title: "Data-driven decisions",
//     desc: "Dashboards and reports that reveal what actually converts.",
//   },
// ];

// const CORE_FEATURES = [
//   { icon: Zap, title: "Real-Time Processing", desc: "Sub-second lead capture and distribution." },
//   { icon: Brain, title: "AI Lead Scoring", desc: "Predictive analytics with 94% accuracy." },
//   { icon: GitMerge, title: "Smart Routing", desc: "Intelligent assignment across multiple criteria." },
//   { icon: Workflow, title: "Visual Automation Builder", desc: "No-code workflow design interface." },
//   { icon: ChartColumn, title: "Advanced Analytics", desc: "Custom dashboards with 50+ metrics." },
//   { icon: Shield, title: "Enterprise Security", desc: "SOC 2, GDPR, and HIPAA compliant." },
// ];

// const JOURNEY_1 = [
//   { icon: Zap, label: "Real-time capture" },
//   { icon: Brain, label: "AI scoring" },
//   { icon: GitMerge, label: "Smart routing" },
//   { icon: Workflow, label: "Workflow trigger" },
//   { icon: CheckCircle2, label: "Lead qualified" },
//   { icon: Database, label: "Data synced" },
//   { icon: Gauge, label: "Performance tracked" },
//   { icon: Rocket, label: "Deal accelerated" },
// ];

// const JOURNEY_2 = [
//   { icon: Lock, label: "Data encryption" },
//   { icon: Globe, label: "API integration" },
//   { icon: ChartColumn, label: "Performance metrics" },
//   { icon: Layers, label: "Custom dashboard" },
//   { icon: Cpu, label: "Model retraining" },
//   { icon: Smartphone, label: "Omnichannel delivery" },
//   { icon: Settings, label: "Automation rules" },
//   { icon: CheckCircle2, label: "Audit trail" },
// ];

// const FAQS = [
//   {
//     q: "What powers the AI lead scoring?",
//     a: "LMSBOTS uses machine learning models trained on prospect behavior, engagement patterns, and demographic data to score leads by conversion probability, helping your sales team prioritize high-value opportunities.",
//   },
//   {
//     q: "Which sources can the platform capture leads from?",
//     a: "Leads can be captured from websites, mobile apps, social media, chatbots, and third-party CRMs, with unified APIs keeping every channel synchronized in real time.",
//   },
//   {
//     q: "How does workflow automation work?",
//     a: "The drag-and-drop automation builder lets you trigger personalized email sequences, SMS campaigns, task assignments, and follow-up reminders based on lead behavior, time delays, or custom conditions.",
//   },
//   {
//     q: "Is the platform secure and compliant?",
//     a: "Yes. LMSBOTS uses end-to-end encryption, is SOC 2 Type II compliant, supports GDPR and HIPAA requirements, and offers role-based access control, audit logs, and data residency options.",
//   },
//   {
//     q: "Can the infrastructure scale with my business?",
//     a: "The platform runs on auto-scaling cloud infrastructure with a 99.99% uptime SLA and global CDN delivery, so performance stays consistent as lead volumes grow.",
//   },
//   {
//     q: "Which integrations are available?",
//     a: "LMSBOTS offers 50+ native integrations spanning CRM, marketing, and communication tools, with RESTful APIs, GraphQL, webhooks, and OpenAPI documentation for custom connections.",
//   },
// ];

// const JSON_LD = [
//   {
//     "@context": "https://schema.org",
//     "@type": "SoftwareApplication",
//     name: "LMSBOTS Lead Management Platform",
//     url: `${SITE_URL}${PATH}`,
//     applicationCategory: "BusinessApplication",
//     applicationSubCategory: "Lead Management / Marketing Automation",
//     operatingSystem: "Web, Android, iOS",
//     description: DESCRIPTION,
//     publisher: { "@id": `${SITE_URL}/#organization` },
//     featureList: FEATURES.map((f) => f.title),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "FAQPage",
//     mainEntity: FAQS.map(({ q, a }) => ({
//       "@type": "Question",
//       name: q,
//       acceptedAnswer: { "@type": "Answer", text: a },
//     })),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "BreadcrumbList",
//     itemListElement: [
//       { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
//       { "@type": "ListItem", position: 2, name: "Technology", item: `${SITE_URL}${PATH}` },
//     ],
//   },
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 24 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
// };

// const stagger = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
// };

// // Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
// const MARQUEE_CSS = `
// .re-track{display:flex;width:max-content}
// @keyframes re-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes re-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
// @media (prefers-reduced-motion: no-preference){
//   .re-left{animation:re-left 45s linear infinite}
//   .re-right{animation:re-right 45s linear infinite}
//   .re-pause:hover .re-track,.re-pause:focus-within .re-track{animation-play-state:paused}
// }
// @media (prefers-reduced-motion: reduce){
//   .re-track{width:auto;flex-wrap:wrap;justify-content:center}
//   .re-dup{display:none}
// }
// `;

// // ---------- Plain, neutral building blocks (same theme as Real Estate) ----------
// const Pill = ({ icon: Icon, children }) => (
//   <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-700 shadow-sm">
//     {Icon ? <Icon className="h-3.5 w-3.5 text-[#0f9d86]" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#12dfbd]" />}
//     {children}
//   </div>
// );

// const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
//   <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
//     <Pill icon={icon}>{pill}</Pill>
//     <h2
//       id={id}
//       className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
//     >
//       {before} <span className="font-normal text-[#48247f]">{highlight}</span>
//       {after ? ` ${after}` : ""}
//     </h2>
//     {text && <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">{text}</p>}
//     <div className="mx-auto mt-6 h-1 w-16 rounded-full bg-[#12dfbd]" />
//   </div>
// );

// const IconTile = ({ icon: Icon, size = "md" }) => (
//   <div
//     className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition-colors duration-300 group-hover:bg-[#e3faf5] group-hover:text-[#0f9d86] ${
//       size === "lg" ? "h-14 w-14" : "h-12 w-12"
//     }`}
//   >
//     <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
//   </div>
// );

// const CARD =
//   "group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0";

// const ACCENT_BAR =
//   "absolute left-0 top-0 h-0.5 w-full origin-left scale-x-0 bg-[#12dfbd] transition-transform duration-500 ease-out group-hover:scale-x-100";

// const JourneyChip = ({ icon: Icon, label, dup = false }) => (
//   <li
//     aria-hidden={dup ? "true" : undefined}
//     className={`${dup ? "re-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-medium text-slate-700 shadow-sm sm:text-base`}
//   >
//     <Icon className="h-4 w-4 text-slate-500" />
//     {label}
//   </li>
// );

// const Technology = () => {
//   const reduced = useReducedMotion();
//   const item = reduced ? undefined : fadeUp;
//   const group = reduced ? undefined : stagger;
//   const initial = reduced ? false : "hidden";

//   return (
//     <>
//       <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
//       <style>{MARQUEE_CSS}</style>

//       <main id="main-content" className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
//         {/* ================= HERO (slate surface + faint line grid + teal blur, same as Real Estate) ================= */}
//         <section
//           id="technology-hero"
//           aria-labelledby="technology-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-b from-slate-50 to-white"
//         >
//           <div
//             className="pointer-events-none absolute inset-0 -z-10"
//             style={{
//               backgroundImage:
//                 "linear-gradient(#0f172a0d 1px, transparent 1px), linear-gradient(90deg, #0f172a0d 1px, transparent 1px)",
//               backgroundSize: "44px 44px",
//               WebkitMaskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
//               maskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
//             }}
//           />
//           <div className="pointer-events-none absolute -right-24 top-10 -z-10 h-80 w-80 rounded-full bg-[#12dfbd]/15 blur-3xl" />

//           <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
//             <motion.div
//               initial={initial}
//               animate="visible"
//               variants={group}
//               className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
//             >
//               <motion.div variants={item}>
//                 <Pill icon={Cpu}>Enterprise Lead Management Platform</Pill>
//               </motion.div>

//               <motion.h1
//                 id="technology-heading"
//                 variants={item}
//                 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
//               >
//                 Intelligent lead management for the{" "}
//                 <span className="font-normal text-[#48247f]">digital age</span>
//               </motion.h1>

//               <motion.p
//                 variants={item}
//                 className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-slate-600 sm:text-base lg:mx-0 lg:text-[17px]"
//               >
//                 Enterprise-grade technology combining AI analytics, omnichannel automation, and scalable
//                 infrastructure to transform how teams capture, nurture, and convert leads at scale.
//               </motion.p>

//               <motion.div
//                 variants={item}
//                 className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
//               >
//                 <Link
//                   to="/contact"
//                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Get a Demo
//                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//                 </Link>
//                 <Link
//                   to="/features"
//                   className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-6 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Explore Features
//                 </Link>
//               </motion.div>

//               <motion.ul
//                 variants={item}
//                 className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
//               >
//                 {HERO_POINTS.map((p) => (
//                   <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-slate-700 sm:text-sm">
//                     <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
//                     {p}
//                   </li>
//                 ))}
//               </motion.ul>
//             </motion.div>

//             {/* Plain image: single rounded frame, no tinted block behind, no double border */}
//             <motion.div
//               initial={reduced ? false : { opacity: 0, y: 30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7, ease: "easeOut" }}
//               className="relative mx-auto w-full max-w-[600px] lg:max-w-none"
//             >
//               <img
//                 src={TechnologyImage}
//                 alt="LMSBOTS lead management platform dashboard showing AI scoring, automation workflows and analytics"
//                 width="1200"
//                 height="800"
//                 fetchpriority="high"
//                 decoding="async"
//                 className="h-auto w-full rounded-2xl border border-slate-200 object-cover"
//               />
//             </motion.div>
//           </div>
//         </section>

//         {/* ================= FEATURES ================= */}
//         <section
//           id="technology-features"
//           aria-labelledby="technology-features-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-features-heading"
//               pill="Platform Capabilities"
//               icon={Layers}
//               before="Built for"
//               highlight="scale & performance"
//               text="Leverage cutting-edge technology to optimize every stage of your lead management lifecycle."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
//             >
//               {FEATURES.map((f) => (
//                 <motion.li key={f.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={f.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
//                   <p className="text-sm leading-[1.75] text-slate-600">{f.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= TECH STACK ================= */}
//         <section
//           id="technology-stack"
//           aria-labelledby="technology-stack-heading"
//           className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-stack-heading"
//               pill="Modern Technology Stack"
//               icon={Cpu}
//               before="Built on"
//               highlight="cutting-edge infrastructure"
//               text="Enterprise-grade technologies powering intelligent lead management."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
//             >
//               {TECH_STACK.map((t) => (
//                 <motion.li key={t.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={t.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{t.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-600">{t.desc}</p>
//                   <div className="mt-3 inline-block rounded-lg bg-[#e3faf5] px-3 py-1.5 font-mono text-xs text-[#0f9d86]">
//                     {t.tech}
//                   </div>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WORKFLOW (plain numbered timeline) ================= */}
//         <section
//           id="technology-workflow"
//           aria-labelledby="technology-workflow-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-workflow-heading"
//               pill="Data Pipeline"
//               icon={RefreshCw}
//               before="From ingestion to"
//               highlight="intelligent action"
//               text="End-to-end lead processing workflow with real-time analytics."
//             />

//             <ol className="relative grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
//               <div
//                 aria-hidden="true"
//                 className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-slate-300 md:block"
//               />

//               {WORKFLOW.map((w, i) => {
//                 const Icon = w.icon;
//                 const last = i === WORKFLOW.length - 1;
//                 return (
//                   <li key={w.title} className="relative flex gap-4 md:flex-col md:items-center md:gap-5 md:text-center">
//                     {!last && (
//                       <div
//                         aria-hidden="true"
//                         className="absolute left-6 top-12 -bottom-8 w-px -translate-x-1/2 bg-slate-300 md:hidden"
//                       />
//                     )}

//                     <div className="relative z-10 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-700">
//                       <Icon className="h-5 w-5" />
//                       <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-800 text-[11px] font-semibold text-white">
//                         {i + 1}
//                       </span>
//                     </div>

//                     <div className="min-w-0 pb-2">
//                       <h3 className="mb-3 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
//                       <ul className="space-y-1.5 text-sm text-slate-600">
//                         {w.steps.map((s) => (
//                           <li key={s} className="flex items-center gap-2 md:justify-center">
//                             <span aria-hidden="true" className="h-1 w-1 flex-shrink-0 rounded-full bg-slate-400" />
//                             {s}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </li>
//                 );
//               })}
//             </ol>
//           </div>
//         </section>

//         {/* ================= BENEFITS ================= */}
//         <section
//           id="technology-benefits"
//           aria-labelledby="technology-benefits-heading"
//           className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-benefits-heading"
//               pill="Key Benefits"
//               icon={TrendingUp}
//               before="Why teams choose"
//               highlight="LMSBOTS"
//               text="Automate, analyze, and scale your lead pipeline with confidence."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {BENEFITS.map((b) => (
//                 <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={b.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-600">{b.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= CORE FEATURES ================= */}
//         <section
//           id="technology-core"
//           aria-labelledby="technology-core-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-core-heading"
//               pill="Core Capabilities"
//               before="Powerful features for"
//               highlight="intelligent lead management"
//               text="Everything you need to optimize lead management at scale."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
//             >
//               {CORE_FEATURES.map((f) => (
//                 <motion.li key={f.title} variants={item} className={`${CARD} flex items-start gap-4 p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <IconTile icon={f.icon} />
//                   <div className="min-w-0">
//                     <h3 className="mb-1.5 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
//                     <p className="text-sm leading-[1.7] text-slate-600">{f.desc}</p>
//                   </div>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= LEAD PIPELINE (plain strip) ================= */}
//         <section
//           id="technology-journey"
//           aria-labelledby="technology-journey-heading"
//           className="relative w-full overflow-hidden border-t border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-journey-heading"
//               pill="Lead Processing Pipeline"
//               before="The complete"
//               highlight="lead journey"
//               text="See how leads flow through our automated processing engine with real-time decisioning."
//             />
//           </div>

//           <div
//             className="re-pause relative space-y-4"
//             role="group"
//             aria-label="Examples of stages in the lead processing pipeline"
//           >
//             <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-slate-50 to-transparent sm:w-32" />
//             <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-slate-50 to-transparent sm:w-32" />

//             {[
//               { list: JOURNEY_1, dir: "re-left" },
//               { list: JOURNEY_2, dir: "re-right" },
//             ].map(({ list, dir }) => (
//               <div key={dir} className="overflow-hidden">
//                 <ul className={`re-track ${dir}`}>
//                   {list.map((j) => (
//                     <JourneyChip key={j.label} {...j} />
//                   ))}
//                   {list.map((j) => (
//                     <JourneyChip key={`dup-${j.label}`} dup {...j} />
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>

//           <p className="mx-auto mt-10 max-w-3xl px-4 text-center text-[15px] leading-[1.75] text-slate-600 sm:px-10 sm:text-base">
//             Process millions of leads with sub-second latency. Our distributed architecture ensures high
//             availability, fault tolerance, and consistent performance at any scale.
//           </p>
//         </section>

//         {/* ================= FAQ ================= */}
//         <section
//           id="technology-faq"
//           aria-labelledby="technology-faq-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="technology-faq-heading"
//               pill="FAQ"
//               before="Lead management technology"
//               highlight="questions answered"
//             />

//             <div className="space-y-3">
//               {FAQS.map(({ q, a }, i) => (
//                 <details
//                   key={q}
//                   open={i === 0}
//                   className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-colors open:border-slate-300"
//                 >
//                   <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#28194f] sm:px-6 [&::-webkit-details-marker]:hidden">
//                     <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
//                     <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition-all duration-300 group-open:rotate-180 group-open:bg-[#e3faf5] group-open:text-[#0f9d86]">
//                       <ChevronDown className="h-5 w-5" />
//                     </span>
//                   </summary>
//                   <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-600 sm:px-6 sm:text-[15px]">{a}</p>
//                 </details>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ================= CLOSING CTA ================= */}
//         <section
//           aria-labelledby="technology-cta-heading"
//           className="w-full bg-white px-4 pb-10 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
//         >
//           <div className="mx-auto w-full max-w-[1300px] rounded-[1.5rem] border border-slate-200 bg-slate-50 px-5 py-12 text-center sm:rounded-[2rem] sm:px-12 sm:py-16">
//             <h2
//               id="technology-cta-heading"
//               className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
//             >
//               Ready to <span className="font-normal text-[#48247f]">scale your lead pipeline?</span>
//             </h2>
//             <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">
//               See how LMSBOTS fits your workflow. In a live demo we'll cover AI lead scoring, omnichannel
//               capture, workflow automation, real-time analytics, and security.
//             </p>
//             <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
//               <Link
//                 to="/contact"
//                 className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 Get a Demo
//                 <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//               </Link>
//               <Link
//                 to="/pricing"
//                 className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-7 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 View Pricing
//               </Link>
//             </div>
//           </div>
//         </section>
//       </main>
//     </>
//   );
// };

// export default Technology;









import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import {
  Shield,
  ChartColumn,
  Zap,
  GitMerge,
  CheckCircle2,
  Smartphone,
  Rocket,
  Cpu,
  Cloud,
  Database,
  Code,
  Globe,
  Lock,
  Layers,
  Brain,
  Gauge,
  Binary,
  GitBranch,
  Workflow,
  Settings,
  TrendingUp,
  ArrowRight,
  ChevronDown,
  RefreshCw,
  Users,
} from "lucide-react";
import TechnologyImage from "../../assets/Technology.jpeg";
// NOTE: adjust this path to wherever Seo.js lives in your project
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/solutions/technology";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

// ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
const HERO_POINTS = ["AI lead scoring", "Workflow automation", "Real-time analytics"];

const FEATURES = [
  {
    icon: Brain,
    title: "AI-Powered Lead Scoring & Predictive Analytics",
    desc: "Machine learning analyzes prospect behavior, engagement, and demographics, then scores leads by conversion probability so your team works high-value opportunities first.",
  },
  {
    icon: Globe,
    title: "Omnichannel Lead Capture & Integration",
    desc: "Capture leads from websites, mobile apps, social platforms, chatbots, and third-party CRMs. Unified APIs keep every channel in real-time sync with a single source of truth.",
  },
  {
    icon: Workflow,
    title: "Intelligent Workflow Automation Engine",
    desc: "Design nurturing workflows with a drag-and-drop builder. Trigger personalized emails, SMS campaigns, task assignments, and reminders based on behavior or custom conditions.",
  },
  {
    icon: Gauge,
    title: "Real-Time Analytics & Custom Dashboards",
    desc: "Customizable dashboards surface conversion funnels, cohort analysis, and ROI tracking in real time, with API export for custom reporting.",
  },
  {
    icon: Lock,
    title: "Enterprise-Grade Security & Compliance",
    desc: "End-to-end encryption, SOC 2 Type II compliance, GDPR readiness, and role-based access control keep sensitive lead data protected at all times.",
  },
  {
    icon: Cloud,
    title: "Scalable Cloud Infrastructure",
    desc: "Auto-scaling cloud architecture handles millions of leads with a 99.99% uptime SLA, global CDN delivery, and cost-efficient serverless scaling.",
  },
];

const TECH_STACK = [
  {
    icon: Brain,
    title: "AI & Machine Learning",
    desc: "Neural networks for lead scoring and prediction",
    tech: "TensorFlow, PyTorch, scikit-learn",
  },
  {
    icon: Cloud,
    title: "Cloud Infrastructure",
    desc: "Multi-cloud deployment with auto-scaling",
    tech: "AWS, Azure, Kubernetes, Docker",
  },
  {
    icon: Database,
    title: "Data Processing",
    desc: "Real-time stream processing at scale",
    tech: "Apache Kafka, Redis, PostgreSQL",
  },
  {
    icon: Lock,
    title: "Security Framework",
    desc: "Zero-trust architecture with encryption",
    tech: "AES-256, SSL/TLS, OAuth 2.0",
  },
  {
    icon: Code,
    title: "API & Integration",
    desc: "RESTful APIs with comprehensive documentation",
    tech: "GraphQL, Webhooks, OpenAPI",
  },
  {
    icon: Smartphone,
    title: "Omnichannel Delivery",
    desc: "Multi-channel communication engine",
    tech: "Twilio, SendGrid, WhatsApp API",
  },
];

const WORKFLOW = [
  {
    icon: Binary,
    title: "Data Ingestion",
    steps: ["Multi-source capture", "Data enrichment", "Deduplication", "Validation layer"],
  },
  {
    icon: Brain,
    title: "Intelligent Processing",
    steps: ["AI scoring", "Behavior analysis", "Segmentation", "Priority routing"],
  },
  {
    icon: GitBranch,
    title: "Workflow Execution",
    steps: ["Automated sequences", "Multi-channel delivery", "A/B testing", "Performance tracking"],
  },
  {
    icon: ChartColumn,
    title: "Analytics & Optimization",
    steps: ["Real-time dashboards", "Conversion analysis", "ROI reporting", "Continuous improvement"],
  },
];

const BENEFITS = [
  {
    icon: Zap,
    title: "Real-time processing",
    desc: "Sub-second lead capture and distribution across every channel.",
  },
  {
    icon: Brain,
    title: "Predictive lead scoring",
    desc: "Analytics that forecast deal closure with 94% accuracy.",
  },
  {
    icon: GitMerge,
    title: "Smart routing",
    desc: "Intelligent lead assignment based on multiple criteria.",
  },
  {
    icon: TrendingUp,
    title: "Data-driven decisions",
    desc: "Dashboards and reports that reveal what actually converts.",
  },
];

const CORE_FEATURES = [
  { icon: Zap, title: "Real-Time Processing", desc: "Sub-second lead capture and distribution." },
  { icon: Brain, title: "AI Lead Scoring", desc: "Predictive analytics with 94% accuracy." },
  { icon: GitMerge, title: "Smart Routing", desc: "Intelligent assignment across multiple criteria." },
  { icon: Workflow, title: "Visual Automation Builder", desc: "No-code workflow design interface." },
  { icon: ChartColumn, title: "Advanced Analytics", desc: "Custom dashboards with 50+ metrics." },
  { icon: Shield, title: "Enterprise Security", desc: "SOC 2, GDPR, and HIPAA compliant." },
];

const JOURNEY_1 = [
  { icon: Zap, label: "Real-time capture" },
  { icon: Brain, label: "AI scoring" },
  { icon: GitMerge, label: "Smart routing" },
  { icon: Workflow, label: "Workflow trigger" },
  { icon: CheckCircle2, label: "Lead qualified" },
  { icon: Database, label: "Data synced" },
  { icon: Gauge, label: "Performance tracked" },
  { icon: Rocket, label: "Deal accelerated" },
];

const JOURNEY_2 = [
  { icon: Lock, label: "Data encryption" },
  { icon: Globe, label: "API integration" },
  { icon: ChartColumn, label: "Performance metrics" },
  { icon: Layers, label: "Custom dashboard" },
  { icon: Cpu, label: "Model retraining" },
  { icon: Smartphone, label: "Omnichannel delivery" },
  { icon: Settings, label: "Automation rules" },
  { icon: CheckCircle2, label: "Audit trail" },
];

const FAQS = [
  {
    q: "What powers the AI lead scoring?",
    a: "LMSBOTS uses machine learning models trained on prospect behavior, engagement patterns, and demographic data to score leads by conversion probability, helping your sales team prioritize high-value opportunities.",
  },
  {
    q: "Which sources can the platform capture leads from?",
    a: "Leads can be captured from websites, mobile apps, social media, chatbots, and third-party CRMs, with unified APIs keeping every channel synchronized in real time.",
  },
  {
    q: "How does workflow automation work?",
    a: "The drag-and-drop automation builder lets you trigger personalized email sequences, SMS campaigns, task assignments, and follow-up reminders based on lead behavior, time delays, or custom conditions.",
  },
  {
    q: "Is the platform secure and compliant?",
    a: "Yes. LMSBOTS uses end-to-end encryption, is SOC 2 Type II compliant, supports GDPR and HIPAA requirements, and offers role-based access control, audit logs, and data residency options.",
  },
  {
    q: "Can the infrastructure scale with my business?",
    a: "The platform runs on auto-scaling cloud infrastructure with a 99.99% uptime SLA and global CDN delivery, so performance stays consistent as lead volumes grow.",
  },
  {
    q: "Which integrations are available?",
    a: "LMSBOTS offers 50+ native integrations spanning CRM, marketing, and communication tools, with RESTful APIs, GraphQL, webhooks, and OpenAPI documentation for custom connections.",
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "LMSBOTS Lead Management Platform",
    url: `${SITE_URL}${PATH}`,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Lead Management / Marketing Automation",
    operatingSystem: "Web, Android, iOS",
    description: DESCRIPTION,
    publisher: { "@id": `${SITE_URL}/#organization` },
    featureList: FEATURES.map((f) => f.title),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Technology", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};

// Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
const MARQUEE_CSS = `
.re-track{display:flex;width:max-content}
@keyframes re-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes re-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
@media (prefers-reduced-motion: no-preference){
  .re-left{animation:re-left 45s linear infinite}
  .re-right{animation:re-right 45s linear infinite}
  .re-pause:hover .re-track,.re-pause:focus-within .re-track{animation-play-state:paused}
}
@media (prefers-reduced-motion: reduce){
  .re-track{width:auto;flex-wrap:wrap;justify-content:center}
  .re-dup{display:none}
}
`;

// ---------- Plain, neutral building blocks (same theme as Real Estate) ----------
const Pill = ({ icon: Icon, children }) => (
  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-700 shadow-sm">
    {Icon ? <Icon className="h-3.5 w-3.5 text-[#0f9d86]" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#12dfbd]" />}
    {children}
  </div>
);

const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
  <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
    <Pill icon={icon}>{pill}</Pill>
    <h2
      id={id}
      className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
    >
      {before} <span className="font-normal text-[#48247f]">{highlight}</span>
      {after ? ` ${after}` : ""}
    </h2>
    {text && <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">{text}</p>}
    <div className="mx-auto mt-6 h-1 w-16 rounded-full bg-[#12dfbd]" />
  </div>
);

const IconTile = ({ icon: Icon, size = "md" }) => (
  <div
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition-colors duration-300 group-hover:bg-[#e3faf5] group-hover:text-[#0f9d86] ${
      size === "lg" ? "h-14 w-14" : "h-12 w-12"
    }`}
  >
    <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
  </div>
);

const CARD =
  "group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0";

const ACCENT_BAR =
  "absolute left-0 top-0 h-0.5 w-full origin-left scale-x-0 bg-[#12dfbd] transition-transform duration-500 ease-out group-hover:scale-x-100";

const JourneyChip = ({ icon: Icon, label, dup = false }) => (
  <li
    aria-hidden={dup ? "true" : undefined}
    className={`${dup ? "re-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-medium text-slate-700 shadow-sm sm:text-base`}
  >
    <Icon className="h-4 w-4 text-slate-500" />
    {label}
  </li>
);

const Technology = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
      <style>{MARQUEE_CSS}</style>

      <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
        {/* ================= HERO (slate surface + faint line grid + teal blur, same as Real Estate) ================= */}
        <section
          id="technology-hero"
          aria-labelledby="technology-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-b from-slate-50 to-white"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10"
            style={{
              backgroundImage:
                "linear-gradient(#0f172a0d 1px, transparent 1px), linear-gradient(90deg, #0f172a0d 1px, transparent 1px)",
              backgroundSize: "44px 44px",
              WebkitMaskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
              maskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
            }}
          />
          <div className="pointer-events-none absolute -right-24 top-10 -z-10 h-80 w-80 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
            <motion.div
              initial={initial}
              animate="visible"
              variants={group}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div variants={item}>
                <Pill icon={Cpu}>Enterprise Lead Management Platform</Pill>
              </motion.div>

              <motion.h1
                id="technology-heading"
                variants={item}
                className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
              >
                Intelligent lead management for the{" "}
                <span className="font-normal text-[#48247f]">digital age</span>
              </motion.h1>

              <motion.p
                variants={item}
                className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-slate-600 sm:text-base lg:mx-0 lg:text-[17px]"
              >
                Enterprise-grade technology combining AI analytics, omnichannel automation, and scalable
                infrastructure to transform how teams capture, nurture, and convert leads at scale.
              </motion.p>

              <motion.div
                variants={item}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Get a Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-6 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore Features
                </Link>
              </motion.div>

              <motion.ul
                variants={item}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-slate-700 sm:text-sm">
                    <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            {/* Hero image — simple & clean, matching Insurance / Healthcare */}
            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              {/* Plain tinted block sits below the image */}
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={TechnologyImage}
                  alt="LMSBOTS lead management platform dashboard showing AI scoring, automation workflows and analytics"
                  width="1200"
                  height="800"
                  fetchpriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ================= FEATURES ================= */}
        <section
          id="technology-features"
          aria-labelledby="technology-features-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-features-heading"
              pill="Platform Capabilities"
              icon={Layers}
              before="Built for"
              highlight="scale & performance"
              text="Leverage cutting-edge technology to optimize every stage of your lead management lifecycle."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={f.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                  <p className="text-sm leading-[1.75] text-slate-600">{f.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= TECH STACK ================= */}
        <section
          id="technology-stack"
          aria-labelledby="technology-stack-heading"
          className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-stack-heading"
              pill="Modern Technology Stack"
              icon={Cpu}
              before="Built on"
              highlight="cutting-edge infrastructure"
              text="Enterprise-grade technologies powering intelligent lead management."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {TECH_STACK.map((t) => (
                <motion.li key={t.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={t.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{t.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-600">{t.desc}</p>
                  <div className="mt-3 inline-block rounded-lg bg-[#e3faf5] px-3 py-1.5 font-mono text-xs text-[#0f9d86]">
                    {t.tech}
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WORKFLOW (plain numbered timeline) ================= */}
        <section
          id="technology-workflow"
          aria-labelledby="technology-workflow-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-workflow-heading"
              pill="Data Pipeline"
              icon={RefreshCw}
              before="From ingestion to"
              highlight="intelligent action"
              text="End-to-end lead processing workflow with real-time analytics."
            />

            <ol className="relative grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
              <div
                aria-hidden="true"
                className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-slate-300 md:block"
              />

              {WORKFLOW.map((w, i) => {
                const Icon = w.icon;
                const last = i === WORKFLOW.length - 1;
                return (
                  <li key={w.title} className="relative flex gap-4 md:flex-col md:items-center md:gap-5 md:text-center">
                    {!last && (
                      <div
                        aria-hidden="true"
                        className="absolute left-6 top-12 -bottom-8 w-px -translate-x-1/2 bg-slate-300 md:hidden"
                      />
                    )}

                    <div className="relative z-10 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-700">
                      <Icon className="h-5 w-5" />
                      <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-800 text-[11px] font-semibold text-white">
                        {i + 1}
                      </span>
                    </div>

                    <div className="min-w-0 pb-2">
                      <h3 className="mb-3 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
                      <ul className="space-y-1.5 text-sm text-slate-600">
                        {w.steps.map((s) => (
                          <li key={s} className="flex items-center gap-2 md:justify-center">
                            <span aria-hidden="true" className="h-1 w-1 flex-shrink-0 rounded-full bg-slate-400" />
                            {s}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </section>

        {/* ================= BENEFITS ================= */}
        <section
          id="technology-benefits"
          aria-labelledby="technology-benefits-heading"
          className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-benefits-heading"
              pill="Key Benefits"
              icon={TrendingUp}
              before="Why teams choose"
              highlight="LMSBOTS"
              text="Automate, analyze, and scale your lead pipeline with confidence."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {BENEFITS.map((b) => (
                <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={b.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-600">{b.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= CORE FEATURES ================= */}
        <section
          id="technology-core"
          aria-labelledby="technology-core-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-core-heading"
              pill="Core Capabilities"
              before="Powerful features for"
              highlight="intelligent lead management"
              text="Everything you need to optimize lead management at scale."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {CORE_FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} flex items-start gap-4 p-6`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={f.icon} />
                  <div className="min-w-0">
                    <h3 className="mb-1.5 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                    <p className="text-sm leading-[1.7] text-slate-600">{f.desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= LEAD PIPELINE (plain strip) ================= */}
        <section
          id="technology-journey"
          aria-labelledby="technology-journey-heading"
          className="relative w-full overflow-hidden border-t border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-journey-heading"
              pill="Lead Processing Pipeline"
              before="The complete"
              highlight="lead journey"
              text="See how leads flow through our automated processing engine with real-time decisioning."
            />
          </div>

          <div
            className="re-pause relative space-y-4"
            role="group"
            aria-label="Examples of stages in the lead processing pipeline"
          >
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-slate-50 to-transparent sm:w-32" />
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-slate-50 to-transparent sm:w-32" />

            {[
              { list: JOURNEY_1, dir: "re-left" },
              { list: JOURNEY_2, dir: "re-right" },
            ].map(({ list, dir }) => (
              <div key={dir} className="overflow-hidden">
                <ul className={`re-track ${dir}`}>
                  {list.map((j) => (
                    <JourneyChip key={j.label} {...j} />
                  ))}
                  {list.map((j) => (
                    <JourneyChip key={`dup-${j.label}`} dup {...j} />
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="mx-auto mt-10 max-w-3xl px-4 text-center text-[15px] leading-[1.75] text-slate-600 sm:px-10 sm:text-base">
            Process millions of leads with sub-second latency. Our distributed architecture ensures high
            availability, fault tolerance, and consistent performance at any scale.
          </p>
        </section>

        {/* ================= FAQ ================= */}
        <section
          id="technology-faq"
          aria-labelledby="technology-faq-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="technology-faq-heading"
              pill="FAQ"
              before="Lead management technology"
              highlight="questions answered"
            />

            <div className="space-y-3">
              {FAQS.map(({ q, a }, i) => (
                <details
                  key={q}
                  open={i === 0}
                  className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-colors open:border-slate-300"
                >
                  <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#28194f] sm:px-6 [&::-webkit-details-marker]:hidden">
                    <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition-all duration-300 group-open:rotate-180 group-open:bg-[#e3faf5] group-open:text-[#0f9d86]">
                      <ChevronDown className="h-5 w-5" />
                    </span>
                  </summary>
                  <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-600 sm:px-6 sm:text-[15px]">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* ================= CLOSING CTA ================= */}
        <section
          aria-labelledby="technology-cta-heading"
          className="w-full bg-white px-4 pb-10 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
        >
          <div className="mx-auto w-full max-w-[1300px] rounded-[1.5rem] border border-slate-200 bg-slate-50 px-5 py-12 text-center sm:rounded-[2rem] sm:px-12 sm:py-16">
            <h2
              id="technology-cta-heading"
              className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
            >
              Ready to <span className="font-normal text-[#48247f]">scale your lead pipeline?</span>
            </h2>
            <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">
              See how LMSBOTS fits your workflow. In a live demo we'll cover AI lead scoring, omnichannel
              capture, workflow automation, real-time analytics, and security.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
              >
                Get a Demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-7 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
              >
                View Pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Technology;